<template>
    <div class="policyDiv ">
        <!-- <div class="main-left">
            <treeMenu
                treeWidth="250px"
                ref="treeMenu"
                initId="0"
                :isEdit="true"
                :policyTreeData="true"
                loadStyle="staticLoad"
                @nodeClick="nodeId"
                :showBox="false">
            </treeMenu>
        </div> -->
        <div class="main-right">
            <div class="searchDiv mb10">
                <div class="ShortCut">
                    <p>名称/关键字：</p>
                    <el-input
                            style="width: auto;"
                            placeholder="名称或关键字"
                            v-model="parameter.name"
                            clearable>
                    </el-input>
                    <p>文件分类：</p>
                    <el-select
                            style="width: auto;"
                            placeholder="选择分类"
                            v-model="parameter.tabsId"
                            clearable>
                            <el-option
                                v-for="item in typeOptions"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                    </el-select>
                    <el-button style="margin-left: 10px" icon="el-icon-search" @click="searchusers" type="primary"
                               size="small">搜 索
                    </el-button>
                    <el-button style="margin-left: 10px" @click="reservise" icon="el-icon-refresh" size="small ">
                        重置
                    </el-button>
                    <div class="btn" v-if="deptPower">
                        <el-button type="primary" @click="addDataClick('add')" icon="el-icon-plus">新增</el-button>
                    </div>
                </div>
            </div>
            <div class="table-con" >
                <el-table
                        v-loading="tableLoading"
                        @sort-change='tableSortChange'
                        ref="MajorListTable"
                        :data="tableData"
                        tooltip-effect="dark"
                        stripe
                        header-row-class-name="table-head"
                        height="100%"
                        style="width: 100%;height: 100%">
                    <el-table-column type="index" label="序号" width="65" align="center"></el-table-column>
                    <el-table-column
                            prop="title"
                            label="文件名称"
                            show-overflow-tooltip>
                    </el-table-column>
                    <!-- <el-table-column
                            prop="keyword"
                            align="center"
                            label="关键字"
                            show-overflow-tooltip>
                    </el-table-column> -->
                    <!-- <el-table-column
                            align="center"
                            label="查看权限"
                            width="120px">
                        <template slot-scope="scope">
                            <el-button type="text" @click="lookOver(scope.row)">查看</el-button>
                        </template>
                    </el-table-column> -->
                    <!-- <el-table-column
                            align="center"
                            label="文件来源"
                            show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{scope.row.type==='1'?'本地上传':'图文链接'}}
                            </template>
                    </el-table-column> -->
                    <el-table-column
                            prop="fileTypeLbl"
                            align="center"
                            label="分类"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop="fileRoles"
                            align="center"
                            label="查看权限"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop="createByUser"
                            align="center"
                            label="创建人"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop="createTime"
                            align="center"
                            label="创建日期"
                            show-overflow-tooltip>
                    </el-table-column>

                    <el-table-column
                            width="180"
                            align="center"
                            label="操作">
                        <template slot-scope="scope">
                            <el-button v-if="deptPower" type="text" @click="editDataClick(scope.row)">编辑</el-button>
                            <el-button  type="text" v-if="deptPower" style="color: red" @click="handleDel(scope.row)">删除</el-button >
                            <!-- <el-button v-if="fileType.indexOf(scope.row.fileSuffix)<0" type="text" :disabled="subState" @click="download(scope.row)">{{scope.row.fileId?'下载':'查看'}}</el-button>
                            <el-button v-if="fileType.indexOf(scope.row.fileSuffix)>-1" type="text" :disabled="subState" @click="preview(scope.row)">预览</el-button> -->
                            <el-button v-if="deptPower" type="text" @click="viewFile(scope.row)">查看</el-button>
                        </template>
                    </el-table-column>
                </el-table>

            </div>
            <div class="mt20 flex-box">
                <div class="flex-1"></div>
                <el-pagination
                    background
                    @size-change="handleSizeChangeUser"
                    @current-change="handleCurrentChangeUser"
                    :current-page.sync="Page.current"
                    :page-size="Page.size"
                    :page-sizes="[10, 15, 20, 40]"
                    layout="total, sizes, prev, pager, next"
                    :total="Page.total">
                </el-pagination>
            </div>

        </div>
        <add-file ref="addfile" :addData="addData" @callBack="getList" @closeAddFiles="closeAddFiles"></add-file>
        <juris-modal ref="jurisModal" :jurisData="jurisData" @closeJuris="closeJuris"></juris-modal>
        <!-- <selectScope
                ref="selectScope"
                :selectScopeData="selectScopeData"
                @closeSelectScope="closeSelectScope"
        />
        <previewFile/> -->
    </div>

</template>

<script>
    import qs from "qs";
    import jurisModal from '@/components/dialog/myfile/fileJurisModal.vue'
    import treeMenu from '@/components/treeMenu/index.vue'
    import addFile from "@/components/dialog/policyFile/addFilePollicy.vue"; //添加
    // import selectScope from "@/components/dialog/jobEvaluation/assessmentManage/selectScope"; //选择考核范围
    import {tableList, tHallPolicyFileDelete, tabsList, aclsEdit, aclsSaveEdit, fileDownload} from '@/api/portrayal/policy'
    import {mapGetters} from "vuex";
    import previewFile from "@/components/common/previewFile.vue"; //文件预览
    import { tHallPolicyFileId } from '@/api/portrayal/policy'
    export default {
        name: "policyFile",
        components: {addFile, treeMenu, jurisModal, /* selectScope, */previewFile},
        data() {
            return {
                fileType:[".doc", ".docx", ".docm",".dot", ".dotx", ".dotm",".odt", ".fodt", ".ott", ".rtf", ".txt",".html", ".htm", ".mht",".pdf", ".djvu", ".fb2", ".epub", ".xps",".xls", ".xlsx", ".xlsm",".xlt", ".xltx", ".xltm",".ods", ".fods", ".ots", ".csv",".pps", ".ppsx", ".ppsm",".ppt", ".pptx", ".pptm",".pot", ".potx", ".potm",".odp", ".fodp", ".otp"].join(","),
                tableLoading: false,
                subState: false,
                tabsData: [],
                tableData: [],
                Page: {
                    total: 0,
                    current: 1,
                    size: 10
                },
                parameter: {
                    name: "",
                    orderBy: '',
                    direction: 'DESC',
                    tabsId: ''
                },
                addData: {
                    state: false,
                    selectData: [],
                    tabsId: '',
                    // path: 'policyFiles'
                },
                editData: {
                    state: false,
                    data: null
                },
                jurisData: {
                    state: false,
                    id: null,
                },
                selectScopeData: {
                    state: false,
                    type: "",
                    key: Date.parse(new Date()),
                    defaultSelected: [],
                    selectedUserListArr: [],
                    depts: [],
                    mans: [],
                    fileId: '',
                    title: '教师权限'
                },
                // juris
                editJuris: {
                    scope: {
                        deptIds: [],
                        userIds: [],
                    },
                },

                typeOptions: [],
            };
        },
        created() {
        },
        computed: {
            ...mapGetters(["permissions", "chooseDept"]),
            deptPower() {
                // return this.permissions.sys_edit_file;
                return true  // 权限问题暂时写死
            },
            deptData() {
                // const deptData = ;
                return JSON.parse(JSON.stringify(this.chooseDept))
            }
        },
        mounted() {
            this.typeOption()
            this.getList()
        },
        methods: {
            viewFile(row){
                let routeData = this.$router.resolve({
                    name:'/fileDetail',
                    query: {
                        id: row.id,
                        fileId:row.fileId||'',
                    }
                });
                window.open(routeData.href);
            },
            typeOption(){
                tabsList('/admin/dict/type/policy_type').then(res => {
                    if (res.data.code == 0) {
                        res.data.data.forEach(e => {
                            let o = {
                                id: Number(e.value),
                                name: e.label,
                            }
                            this.typeOptions.push(o)
                        })
                    }
                })
            },
            preview(row) {
                row.previewPath="policyFiles";
                this.$store.commit('setPreviewFileData',{data:row,state:true})
                // this.$router.push("/previewFile");
            },
            closePreviewFile() {
                this.previewFileData.state = false;
            },
            filterDeptRowById(source, id) {
                let result = "";
                if (source && source.length > 0) {
                    const filterFun = target => {
                        target.forEach(item => {
                            if (item.id == id) {
                                result = item;
                            } else {
                                if (item.children && item.children.length > 0) {
                                    filterFun(item.children);
                                }
                            }
                        });
                    };
                    filterFun(source);
                }
                return result;
            },
            filterDeptTree(source, id) {

                let result = "";
                if (source && source.length > 0) {
                    const filterFun = target => {
                        target.forEach(item => {
                            if (item.id == id && item.children.length < 1) {
                                result = item;
                            }
                            if (item.children && item.children.length > 0) {
                                filterFun(item.children);
                            }
                        });
                    };
                    filterFun(source);
                }
                return result;
            },
            closeSelectScope(data) {
                if (data) {
                    let params = {
                        deptIds: [],
                        userIds: [],
                    }
                    params.deptIds = data.depts.map(
                        item => {
                            return item.id;
                        }
                    );
                    data.mans.forEach(item => {
                        if (item.mans.length > 0) {
                            item.mans.forEach((item, index) => {
                                params.userIds.push(item.userId);
                            });
                        }
                    });
                    let queryObj = {
                        deptIds: params.deptIds,
                        userIds: params.userIds

                    }
                    aclsSaveEdit(queryObj, this.selectScopeData.fileId).then(res => {
                        this.subDisabled = false;
                        if (res.data.code == 0) {
                            this.$message({message: '权限修改成功', type: 'success'});
                            this.selectScopeData.state = false;
                            this.getList()
                        } else {
                            this.$message.success(res.data.msg);
                        }
                    })
                }
            },
            changeJuris() {
                const deptArray = this.editJuris.scope.deptIds.map(item => {
                    return item.id;
                });
                this.selectScopeData.depts = JSON.parse(JSON.stringify(deptArray));
                this.selectScopeData.mans = JSON.parse(
                    JSON.stringify(this.editJuris.scope.userIds)
                );
                this.selectScopeData.state = true;
            },
            closeJuris() {
                this.jurisData.state = false
            },
            lookOver(row) {
                this.jurisData.state = true
                this.$refs.jurisModal.getTreeData(row.fileId)
            },
            searchusers() {
                this.getList(1)
            },
            //清空
            reservise() {
                this.parameter.name = "";
                this.getList()
            },
            //排序方法
            tableSortChange(column) {
                if (column.prop == "fileName") {
                    this.parameter.orderBy = '1'
                    if (column.order === 'descending') {
                        this.parameter.direction = 'DESC';
                    } else {
                        this.parameter.direction = 'ASC';
                    }
                }
                if (column.prop == "createTime") {
                    this.parameter.orderBy = '2'
                    if (column.order === 'descending') {
                        this.parameter.direction = 'DESC';
                    } else {
                        this.parameter.direction = 'ASC';
                    }
                }

                this.getList();
            },

            nodeId(tree) {
                // this.policyType = int
                this.fillType = 0
                this.nameIndexValue = 0
                this.sortType = 0
                if (tree.id == 0) {
                    this.parameter.tabsId = ''
                } else {
                    this.parameter.tabsId = tree.id

                }
                this.getList(1)
            },
            closeAddFiles(val) {
                this.addData.state = val
                this.getList(1)
            },
            addDataClick() {
                this.$refs.addfile.dialogShow('add');
            },
            // 下载
            download(row) {
                // this.subState = true;
                if(row.downUrl){
                    let url = row.downUrl;
                    if(url.indexOf('http') < 0){
                        url = 'http://' + url;
                    }
                    // location.href = url
                    window.open(url)
                    return
                }

                this.$DownLoad('/admin/file/download/' + row.fileId, null,
                    res => {
                    if (res.status == 200) {
                        // this.$message.success("开始下载");
                    } else {
                        this.$alert("下载出错,请稍后重试", "提示", {
                        confirmButtonText: "确定",
                        type: "warning"
                        });
                    }
                    },
                    error => {
                        this.$alert(error, "提示", {
                            confirmButtonText: "确定",
                            type: "warning"
                        });
                    }
                )
            },
            downloadFn(url, name) {
                var x = new XMLHttpRequest();
                x.open("GET", url, true);
                x.responseType = 'blob';
                x.onload = function (e) {
                    var url = window.URL.createObjectURL(x.response)
                    var a = document.createElement('a');
                    a.href = url
                    a.download = name
                    a.click()
                }
                x.send()
            },

            closeEdit() {
                this.editData.state = false;
                this.getList()
            },
            editDataClick(row) {
                this.tableLoading=true;
                tHallPolicyFileId(row.id)
                    .then(({ data }) => {
                        this.tableLoading=false;
                        if (data.code == 0) {
                            this.$refs.addfile.dialogShow('edit',data.data || {});
                        } else {
                            this.$message.error(data.msg || "获取校内公文失败！");
                        }
                    })
                    .catch((err) => {
                        this.tableLoading=false;
                        this.$message.error("服务器异常!");
                    })
            },
            // 删除
            handleDel(row) {
                this.$confirm('是否确认删除:' + row.title, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    tHallPolicyFileDelete(row.id).then(res => {
                        if (res.data.code === 0) {
                            this.$message.success("删除成功");
                            this.getList(1)
                        } else {
                            this.$alert('删除出错,请稍后重试', '提示', {
                                confirmButtonText: '确定',
                                type: 'warning'
                            });
                        }
                    })
                }).catch(function () {
                })
            },
            getList(page) {
                this.tableLoading = true;
                this.Page.current = page ? page : this.Page.current
                let obj = {
                    current: this.Page.current,
                    size: this.Page.size,
                    /*  viewAll: true,*/
                    type: this.parameter.tabsId,
                    keywords: this.parameter.name,
                    // pinyinIndex: '',
                    // orderBy: this.parameter.orderBy,
                    // direction: this.parameter.direction
                }
                tableList(obj).then(res => {
                    if (res.data.code == 0) {
                        this.tableData = res.data.data.records
                        this.Page.total = res.data.data.total;
                        this.tableLoading = false
                    }else {
                        this.$message.error(res.data.msg)
                    }
                }).finally(() => {
                    this.tableLoading = false;
                })

            },
            // 分页
            handleSizeChangeUser(val) {
                this.Page.size = val
                this.getList(1)
            },
            handleCurrentChangeUser(val) {
                this.Page.current = val
                this.getList()
            },
        }

    };
</script>

<style lang="less" scoped>
    @import "./policyFile.less";

    .clickName {
        color: red;
        margin: 0 12px;
    }

</style>
